import {NoAdminRole, UserState} from "../AppState";
import {AppActions} from "../actions";
import {ALLOW_COMPANY_SELECTION, COMPANY_SELECTED} from "../actions/WorkforceClinicAction";
import { USER_LOGGED_IN, USER_LOGGED_IN_FAILED, USER_LOGGED_OUT, USER_LOGIN, SSO_USER_LOGIN, SSO_TOKEN_USER_LOGIN, USER_LOGGED_IN_WRONG_URL } from "../actions/WorkforceOneLoginActions"
import {COMPANY_PERMISSION, USER_PERMISSION_CHANGED} from "../actions/WorkforceOnePermissionActions";
import {defaultCurrentUserPermissions} from "./Defaults/CurrentUserPermissions";

function getCleanUserState(): UserState{
    return {
        isLoading: false,
        isLoggedIn: false,
        loadedSelectedCompanyPermission: false,
        requireCompleteSetup: false,
        showCompanySelection: false,
        role: NoAdminRole,
        currentUserPermissions: defaultCurrentUserPermissions,
    };
}
export default function Workforce1User(state = getCleanUserState(), action: AppActions) : UserState {
    switch (action.type) {
        case USER_LOGIN:{
            return {
                ...state,
                isLoading: true,
                userName: action.payload.userName,
                requireCompleteSetup: false,
                loginResultMessage: undefined
            };
        }
        case USER_LOGGED_IN:{
            return {
                ...state,
                isLoggedIn: true,
                webToken:action.payload.AuthToken,
                isLoading: false,
                userName: action.payload.UserName,
            };
        }
        case USER_LOGGED_IN_WRONG_URL:{
            return {
                ...state,
                isLoggedIn: true,
                isLoading: false,
                loginResultMessage: action.payload.Message,
            };
        }
        case USER_LOGGED_IN_FAILED:{
            return {
                ...state,
                isLoading: false,
                userName: undefined,
            };
        }
        case USER_LOGGED_OUT:{
            return {
                ...state,
                loadedSelectedCompanyPermission: false,
                showCompanySelection: false,
                isLoggedIn: false,
                webToken: undefined,
                userName: undefined,
                isLoading: false,
                selectedCompany: undefined,
                requireCompleteSetup: false,
                loginResultMessage: undefined
            };
        }
        case USER_PERMISSION_CHANGED: {

            return {
                ...state,
                isLoading: false,
                currentUserPermissions:{
                    ...action.payload.userPermission
                }
            };
        }
        case COMPANY_SELECTED: {
            return {
                ...state,
                loadingCompany: action.payload.participationId,
                requireCompleteSetup: false,
                showCompanySelection: false
            };
        }
        case ALLOW_COMPANY_SELECTION: {
          return {
              ...state,
              showCompanySelection: true
          };
      }
        case COMPANY_PERMISSION: { // COMPANY_SELECTION_SUCCESSFUL
            return {
                ...state,
                loadedSelectedCompanyPermission: true,
                loadingCompany: undefined,
                selectedCompany: action.payload.selectedCompany,
                requireCompleteSetup: action.payload.requireCompleteSetup,
                link: action.payload.link,
                role: action.payload.role,
                currentCompanyPermissions: {...action.payload.companyPermission}
            };
        }
        case SSO_USER_LOGIN:
        case SSO_TOKEN_USER_LOGIN: {
          return {
            ...state,
            isLoading: true
          }
        }
        default:
            return state
    }
}
